import List from 'modules/Tickets/List/List'
import Sagas from 'modules/Tickets/List/store/saga'
import Reducer from 'modules/Tickets/List/store/reducer'

export default List

export { Sagas, Reducer }
